import {ChangeDetectionStrategy, Component, Inject, Injectable, signal} from "@angular/core";
import {AvtaleRessursClient, BetingelserModell, Språk} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {lagrerSignal} from "felles-ng2/tjenester/LagrerIndikator";
import {MatToolbar} from "@angular/material/toolbar";
import {TranslateModule} from "@ngx-translate/core";
import {MatButton} from "@angular/material/button";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

const debug = initDebugger('AvtaleGodtaLisensbetingelserDialogKomponent');

/**
 * Modal som lar bruker godta lisensbetingelser.
 */
@Component({
    selector: 'avtale-godta-lisensbetingelser-dialog',
    templateUrl: 'avtale-godta-lisensbetingelser-dialog.html',
    styleUrl: 'avtale-godta-lisensbetingelser-dialog.scss',
    imports: [MatDialogModule, MatToolbar, TranslateModule, MatButton, MatProgressSpinner],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvtaleGodtaLisensbetingelserDialogKomponent {

    static vis(dialog: MatDialog, språk: Språk): MatDialogRef<AvtaleGodtaLisensbetingelserDialogKomponent, AvtaleGodtaLisensbetingelserDialogRespons> {
        return dialog.open(AvtaleGodtaLisensbetingelserDialogKomponent, {data: {språk} as DialogParametre, disableClose: true, ariaLabelledBy: 'avtale-godta-lisensbetingelser-dialog-tittel', width: '80%'});
    }

    static readonly betingelserIkkeGodtatt: AvtaleGodtaLisensbetingelserDialogRespons = {godtatt: false, betingelser: ''}

    betingelser = signal('');
    laster = lagrerSignal();

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private avhengigheter: AvtaleGodtaLisensbetingelserDialogKomponentAvhengigheter,
                private dialogRef: MatDialogRef<AvtaleGodtaLisensbetingelserDialogKomponent, AvtaleGodtaLisensbetingelserDialogRespons>) {
        this.lastBetingelser(parametre.språk);
    }

    godta() {
        this.dialogRef.close({godtatt: true, betingelser: this.betingelser()});
    }

    skrivUt() {
        window.print();
    }

    avbryt() {
        this.dialogRef.close(AvtaleGodtaLisensbetingelserDialogKomponent.betingelserIkkeGodtatt);
    }

    //hjelpemetoder

    private async lastBetingelser(språk: Språk) {
        await this.laster.utfør(async () => {
            let betingelserModell = await this.avhengigheter.betingelser(språk);
            this.betingelser.set(betingelserModell.betingelser);
        })
    }
}

export interface DialogParametre {
    språk: Språk;
}

export interface AvtaleGodtaLisensbetingelserDialogRespons {
    readonly godtatt: boolean;
    readonly betingelser: string;
}

@Injectable()
export class AvtaleGodtaLisensbetingelserDialogKomponentAvhengigheter {

    constructor(private avtaleRessurs: AvtaleRessursClient) {
    }

    betingelser(språk: Språk): Promise<BetingelserModell> {
        return this.avtaleRessurs.hentVilkår({spraak: språk}).somPromise();
    }

}
